import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import CategoryGuidePage from "@/pages/category-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/shoes-spreadsheet-guide",
    element: <CategoryGuidePage />,
  },
  {
    path: "/hoodies-spreadsheet-guide",
    element: <CategoryGuidePage />,
  },
  {
    path: "/tshirts-spreadsheet-guide",
    element: <CategoryGuidePage />,
  },
  {
    path: "/jackets-spreadsheet-guide",
    element: <CategoryGuidePage />,
  },
  {
    path: "/accessories-spreadsheet-guide",
    element: <CategoryGuidePage />,
  },
  {
    path: "/bags-spreadsheet-guide",
    element: <CategoryGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;